<template>
  <NuxtLayout>
      <NuxtPage></NuxtPage>
  </NuxtLayout>
  </template>

<script setup>
</script>
